<template>
  <div class="product-recommendations-container">
    <slot v-if="isVisibleAtPosition" v-bind="{ title, items, isLoading }" />
  </div>
</template>

<script>
import DynamicYieldService from '@/api/services/_shared/dynamic-yield-service'
import { DY_PAGE_TYPES } from '@/services/external-communication/dynamic-yield/dy-events'

const DEFAULT_POSITION = ''

export default {
  name: 'ProductRecommendationsProvider',

  props: {
    /**
     * DY API selector name.
     */
    selectorName: {
      type: String,
      required: true,
    },

    /**
     * Will be used to exclude product in fallback product recommendations.
     */
    excludeProductId: {
      type: Number,
    },

    /**
     * Will be used to verify (target-)position comming from API.
     */
    availablePositions: {
      type: Array,
      default: () => [],
    },

    /**
     * Will be compared to (target-)position comming from API to determine wheter child should render.
     */
    currentPosition: {
      type: String,
      default: DEFAULT_POSITION,
    },

    /**
     * Will be used as target-position if position coming from API is not part of availablePositions.
     */
    fallbackTargetPosition: {
      type: String,
      default: DEFAULT_POSITION,
    },

    pageType: {
      type: String,
      validator(value) {
        return Object.values(DY_PAGE_TYPES).includes(value)
      },
    },
  },

  data() {
    return {
      recommendations: [],
      isLoading: false,
    }
  },

  computed: {
    isVisibleAtPosition() {
      return this.currentPosition === this.targetPosition
    },

    targetPosition() {
      if (!this.recommendations) return undefined // we need recommendations to have a defined target position
      const { position } = this.recommendations
      return this.availablePositions.includes(position) ? position : this.fallbackTargetPosition
    },

    title() {
      return this.recommendations.title || ''
    },

    items() {
      return this.recommendations.items || []
    },
  },

  created() {
    this.fetchProductRecommendations({ useCache: true })
  },

  methods: {
    async fetchProductRecommendations({ useCache, pageData }) {
      const { selectorName, excludeProductId, pageType } = this
      this.isLoading = true
      this.recommendations = await DynamicYieldService.fetchProductRecommendations({
        selectorName,
        excludeProductId,
        useCache,
        pageType,
        pageData,
      })
      this.isLoading = false
    },
  },
}
</script>
